import React from 'react';
import TextComponent from 'shared/components/TextComponent';

const StencilPrinterName = (props) => {
  const name = 'printer_type';

  const {
    parameters,
    onChangeParameter,
    groupName,
    inputClassName,
    errorMessage,
    label,
    required,
    tooltip,
    inputId,
    placeholder,
    className,
    disabled,
  } = props;

  const onChange = e => onChangeParameter(name, e.target.value);

  return (
    <TextComponent
      label={label}
      name={name}
      inputId={inputId}
      value={parameters[name] || ''}
      required={required}
      placeholder={placeholder}
      groupName={groupName}
      onChange={onChange}
      tooltip={tooltip}
      className={className}
      inputClassName={inputClassName}
      errorMessage={errorMessage}
      disabled={disabled} />
  );
};

StencilPrinterName.defaultProps = {
  label: Spree.translations.parameters.printer_type,
  tooltip: Spree.helpForParameters.printer_type,
  required: true,
  inputId: 'printer-type',
};

export default StencilPrinterName;
